import { applyMiddleware, createStore, combineReducers } from "redux";
// eslint-disable-next-line import/no-extraneous-dependencies
import { composeWithDevTools } from "redux-devtools-extension";
import thunkMiddleware from "redux-thunk";

import { AuthInitialState, AuthReducer } from "./reducer/auth";
import { RestaurantInitialState, RestaurantReducer } from "./reducer/restaurant";
import { MenuInitialState, MenuReducer } from "./reducer/menu";

const getInitialState = () => ({
  auth: AuthInitialState,
  restaurant: RestaurantInitialState,
  menu: MenuInitialState
});

const rootReducer = combineReducers({
  auth: AuthReducer,
  restaurant: RestaurantReducer,
  menu: MenuReducer
});

export default function configureStore() {
  const middlewares = [thunkMiddleware];
  const middlewareEnhancer = applyMiddleware(...middlewares);
  const enhancers = [middlewareEnhancer];
  const composedEnhancers = composeWithDevTools(...enhancers);
  const store = createStore(rootReducer, getInitialState(), composedEnhancers);
  return store;
}
